import { OperatorOption } from "types/ui.types"
import { STATISTIC_TYPE } from "types/ReportingDashboard/elements.types"

/**
 * XTAB statistic options (for categorical variables)
 */
export const XTAB_STATISTIC_OPTIONS: OperatorOption[] = [
  { value: STATISTIC_TYPE.N, label: "Count (n)" },
  { value: STATISTIC_TYPE.BIG_N, label: "Weighted Count (N)" },
  { value: STATISTIC_TYPE.ROW_PERCENT, label: "Row %" },
  { value: STATISTIC_TYPE.COL_PERCENT, label: "Col %" },
  { value: STATISTIC_TYPE.INDEX, label: "Index" },
  { value: STATISTIC_TYPE.PERC_PERCENT, label: "Percentage %" },
]

/**
 * DTAB statistic options (for numeric variables)
 */
export const DTAB_STATISTIC_OPTIONS: OperatorOption[] = [
  { value: STATISTIC_TYPE.AVG, label: "Average" },
  { value: STATISTIC_TYPE.BASE_N, label: "Base n" },
  { value: STATISTIC_TYPE.PERC, label: "Percent (yes)" },
  { value: STATISTIC_TYPE.CRR_PERCENT, label: "CRR%" },
  { value: STATISTIC_TYPE.MIN, label: "Minimum" },
  { value: STATISTIC_TYPE.MAX, label: "Maximum" },
  { value: STATISTIC_TYPE.STDDEV, label: "Standard deviation" },
  { value: STATISTIC_TYPE.STDERR, label: "Standard error" },
  { value: STATISTIC_TYPE.MEDIAN, label: "Median" },
  { value: STATISTIC_TYPE.SUM, label: "Sum" },
]
